import { useEffect, useState } from "react";
import { inboxAPI } from "../api/client";

export const INBOX_CHANGED_EVENT = "inbox:changed";
const INBOX_POLL_MS = 60000;

// Unread inbox count: refreshed on navigation, on a timer, and immediately
// when the Inbox page dispatches INBOX_CHANGED_EVENT.
export function useInboxUnreadCount(pathname) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const refresh = () =>
      inboxAPI
        .unreadCount()
        .then((resp) => !cancelled && setCount(resp.data?.unreadCount || 0))
        .catch(() => {});
    refresh();
    const timer = setInterval(refresh, INBOX_POLL_MS);
    const onChanged = (e) =>
      typeof e.detail?.unreadCount === "number" ? setCount(e.detail.unreadCount) : refresh();
    window.addEventListener(INBOX_CHANGED_EVENT, onChanged);
    return () => {
      cancelled = true;
      clearInterval(timer);
      window.removeEventListener(INBOX_CHANGED_EVENT, onChanged);
    };
  }, [pathname]);

  return count;
}
